/* CONCEPTS */
export const MONITOR_LOAD = "MONITOR_LOAD";
export const MONITOR_LOAD_SUCCESS = "MONITOR_LOAD_SUCCESS";
export const MONITOR_ERROR = "MONITOR_ERROR";
export const MONITOR_CLEAN = "MONITOR_CLEAN";

export const EXPORT_ORDERS = "EXPORT_ORDERS"
export const EXPORT_ORDERS_SUCCESS = "EXPORT_ORDERS_SUCCESS"
